/**
 * @Description 拓店-标准版本-审批工作台接口
 */

import { post, get } from '@/common/request/index';

const SHOP_EDIT_APPROVAL_SNAPSHOT_OPTIONS = {
  isMock: false,
  mockId: 532,
  mockSuffix: '/api',
  needHint: true,
};


/**
 * @description 审批列表-tab 数量
 * @yapi https://yapi.lanhanba.com/project/497/interface/api/53283
 */
export function getTabsCount() {
  return post('/approval/count', {}, {
    needHint: true,
  });
}

/**
 * @description 审批列表筛选项
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/61956
 */
export function approvalSelection(params:any) {
  return get(`/approval/selection`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 审批列表
 * @yapi https://yapi.lanhanba.com/project/497/interface/api/50343
 */
export function getTabsApproveList(params:any) {
  return post('/approval/list', { ...params }, {
    needHint: true,
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
  });
}


/**
 * 审批详情（PC端）
 * https://yapi.lanhanba.com/project/532/interface/api/55817
 */
export function getApprovalDetail(params?: any) {
  return post('/approval/detail', { ...params }, {
    needHint: true,
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
  });
}

/**
 * 审批流水记录(PC)
 * https://yapi.lanhanba.com/project/497/interface/api/51407
 */
export function getApprovalRecord(params = {}) {
  return post(`/approval/record`, params, {
    needHint: true,
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
  });
}


/**
 * 加签
 * https://yapi.lanhanba.com/project/532/interface/api/55691
 */
export function counterSign(params:any) {
  return post(`/approval/countersign`, params);
}

/**
 * 转交
 * https://yapi.lanhanba.com/project/532/interface/api/55684
 */
export function transfer(params:any) {
  return post(`/approval/transfer`, params);
}

/**
 * 通过
 * https://yapi.lanhanba.com/project/532/interface/api/55663
 */
export function passApproval(params:any) {
  return post(`/approval/pass`, params);
}
/**
 * 不通过
 * https://yapi.lanhanba.com/project/532/interface/api/55670
 */
export function denyApproval(params:any) {
  return post(`/approval/deny`, params);
}
/**
 * 驳回
 * https://yapi.lanhanba.com/project/532/interface/api/58764
 */
export function rebutApproval(params:any) {
  return post(`/approval/rebut`, params);
}
/**
 * 撤销审批
 * https://yapi.lanhanba.com/project/532/interface/api/55677
 */
export function revokeApproval(params:any) {
  return post(`/approval/revoke`, params);
}

/**
 * 一鸣合同审批撤回
 * https://yapi.lanhanba.com/project/532/interface/api/99710
 */
export function revokeYmOaContractApproval(params:any) {
  return post(`/standard/chancePoint/contract/revoke`, params);
}

/**
 * 提交审批
 * https://yapi.lanhanba.com/project/532/interface/api/55649
 */
export function createApproval(params:any, config = {}) {
  return post(`/approval/create`, params, { ...config });
}

/**
 * 拓店任务关闭理由列表
 * https://yapi.lanhanba.com/project/532/interface/api/99386
 */
export function getTaskCloseReasonList(params = {}) {
  return get(`/standard/task/closeReasonList`, params, {
    needHint: true,
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
  });
}

/**
 * 创建审批获取配置-分支+选择审批人
 * https://yapi.lanhanba.com/project/532/interface/api/79946
 */
export function getApprovalCreatorConfig(params:any) {
  return post(`/approval/creator/config`, params);
}

/**
 * 审批详情用的表单详情（机会点、门店等）
 * https://yapi.lanhanba.com/project/532/interface/api/59758
 */
export function approvalFormDetail(params:any) {
  return post(`/approval/form/detail`, params);
}

/**
 * 门店编辑审批快照详情
 * https://yapi.lanhanba.com/project/532/interface/api/99714
 */
export function getShopEditApprovalSnapshot(params: any) {
  return post('/standard/shop/editApprovalSnapshot', params, SHOP_EDIT_APPROVAL_SNAPSHOT_OPTIONS);
}

/**
 * 审批详情用的保存机会点
 * https://yapi.lanhanba.com/project/532/interface/api/59751
 */
export function chancepointApprovalSave(params:any) {
  return post(`/approval/form/update`, params);
}

/**
 * 审批节点列表，文档用的是app端的文档，pc的没有v2
 * https://yapi.lanhanba.com/project/532/interface/api/65169
 */
export function approvalNodeList(params:any) {
  return post(`/approval/node/list`, params);
}

/**
 * 重启审批，文档用的是app端的文档，pc的没有v2
 * https://yapi.lanhanba.com/project/532/interface/api/65148
 */
export function approvalReboot(params:any) {
  return post(`/approval/reboot`, params);
}

/**
 * 选址地图发起的拓店任务审批详情商圈分页列表
 * https://yapi.lanhanba.com/project/532/interface/api/72246
 */
export function approveTypeOfTaskAreaList(params:any) {
  return post(`/approval/form/cluster/page`, params, {
    needCancel: false,
  });
}

/**
 * 拓店任务审批-设置审批标记
 * https://yapi.lanhanba.com/project/532/interface/api/86421
 */
export function approveTaskClusterSetTab(params:any) {
  return post(`/standard/taskCluster/set/tab`, params);
}

/**
 * 审批详情-拓店任务标记的个数
 * https://yapi.lanhanba.com/project/532/interface/api/86435
 */
export function approveFormClusterCount(params:any) {
  return post(`/approval/form/cluster/count`, params);
}

/**
 * 选址地图发起的拓店任务审批详情商圈聚合
 * https://yapi.lanhanba.com/project/532/interface/api/72323
 */
export function approveTypeOfTaskAreaCluster(params:any) {
  return post(`/approval/form/cluster/map`, params, {
    needCancel: false,
  });
}

/**
 * 创建开店区域-审批详情
 * https://yapi.lanhanba.com/project/532/interface/api/80408
 */
export function modelClusterApprovalDetail(params:any) {
  return post(`/modelCluster/approval/detail`, params, {
    needCancel: false,
  });
}

/**
 * 机会点增加保护
 * https://yapi.lanhanba.com/project/532/interface/api/87443
 */
export function chancePointProtect(params:any) {
  return post(`/standard/chancePoint/protect`, params, {
    needCancel: false,
  });
}
